import { APICore } from "./apiCore";

const api = new APICore();

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const EPISODE_CAPTURE_VIDEO_ENDPOINT = 'api/v1/admin/episode_capture_videos';


function searchEpisodeCaptureVideo(params: any) {
    return api.get(`${baseUrl}/${EPISODE_CAPTURE_VIDEO_ENDPOINT}`, params);
}


export {
    searchEpisodeCaptureVideo
};